(function() {
  // ============================================
  // AXP Quantity Limit
  // Limits specific products to max 6 per cart
  // ============================================

  const LIMIT = 6;
  const LIMITED_HANDLES = [
    'floor-arrangement-service'
  ];

  function getProductHandle() {
    // Get handle from product page URL
    const path = window.location.pathname;
    const match = path.match(/\/products\/([^/?]+)/);
    return match ? match[1] : null;
  }

  function isLimitedProduct(handle) {
    return LIMITED_HANDLES.includes(handle);
  }

  function enforceLimit() {
    const handle = getProductHandle();
    if (!handle || !isLimitedProduct(handle)) return;

    const qtyInput = document.querySelector('[name="quantity"]');
    if (!qtyInput) return;

    // Set max attribute
    qtyInput.setAttribute('max', LIMIT);

    // Watch for changes
    qtyInput.addEventListener('change', function() {
      if (parseInt(this.value) > LIMIT) {
        this.value = LIMIT;
        showLimitMessage();
      }
      if (parseInt(this.value) < 1) {
        this.value = 1;
      }
    });

    // Watch + and - buttons
    document.addEventListener('click', function(e) {
      if (e.target.matches('[name="plus"], .quantity__button[name="plus"], button[aria-label*="Increase"]')) {
        setTimeout(function() {
          const val = parseInt(qtyInput.value);
          if (val > LIMIT) {
            qtyInput.value = LIMIT;
            showLimitMessage();
          }
        }, 50);
      }
    });
  }

  function showLimitMessage() {
    // Remove existing message if any
    const existing = document.getElementById('axp-limit-msg');
    if (existing) existing.remove();

    const msg = document.createElement('p');
    msg.id = 'axp-limit-msg';
    msg.textContent = 'Maximum 6 units per order.';
    msg.style.cssText = 'color: #c0392b; font-size: 13px; margin-top: 8px; font-family: Inter, sans-serif;';

    const qtyInput = document.querySelector('[name="quantity"]');
    if (qtyInput) {
      qtyInput.parentElement.appendChild(msg);
      setTimeout(function() {
        if (msg.parentElement) msg.remove();
      }, 3000);
    }
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceLimit);
  } else {
    enforceLimit();
  }

})();